import React from "react";
import Typography from "@mui/material/Typography";
import { formatCurrency, formatEmpty } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function OffersCell(cell) {
  const lowestOffer = nullCheck(cell, "", "row", "original", "lowestOffer");
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <span style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          color: active ? "white_opacity.100" : "black_solid.80"
        }}
      >
        {cell.value ? (
          `${formatCurrency(lowestOffer)} (${formatEmpty(cell.value)})`
        ) : (
          "(0)"
        )}
      </Typography>
    </span>
  );
}